import { wmfetch } from "@/helpers/wmfetch"; //引用fetch.js
// 获取验证码
export function getCode(data) {
  return wmfetch({
    url: '/api/wechat',
    method: 'get',
    params: data
  })
}
// 微信预警设置-媒体平台列表
export function getAccountList(data) {
  return wmfetch({
    url: '/api/alert/account/site/list',
    method: 'get',
    params: data
  })
}
// 微信预警设置-接收，取消预警（支持批量）
export function setWarn(data) {
  return wmfetch({
    url: '/api/alert/warnning/set',
    method: 'post',
    data: data
  })
}